var _module_exports = "<div ui-view>\n  <div class=\"bg-light lter b-b wrapper-md\">\n    <h1 class=\"m-n font-thin h3\">Restaurant management &raquo; New Restaurant</h1>\n    <small class=\"text-muted\">Quandoo Operation Center</small>\n  </div>\n\n  <div class=\"panel panel-default m-t-sm\">\n    <uib-tabset>\n      <uib-tab heading=\"Portal Configuration\">\n        <div data-ng-include=\"'/app/merchants/portal-configuration/portal-configuration-add.html'\">\n        </div>\n      </uib-tab>\n    </uib-tabset>\n  </div>\n</div>\n";;
var path = '/app/merchants/merchant.add.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/merchants/merchant.add.html
// module id = 1097
// module chunks = 0